import React, { useState } from "react"
import type { ReactNode, PropsWithChildren } from "react"

import BottomDrawer from "~components/shared/drawers/bottom-drawer"
import TripSummaryBar from "~components/pages/listing/checkout/trip-summary-bar"

interface Props extends PropsWithChildren {
    readonly total?: number
    readonly isLoading?: boolean
    readonly renderNavButtons?: () => ReactNode
}

export default function TripSummaryBarWithDrawer({
    total,
    isLoading = false,
    children,
    renderNavButtons,
}: Props) {
    const [drawerIsOpen, setDrawerIsOpen] = useState<boolean>(false)

    const handleClose = () => setDrawerIsOpen(false)

    return (
        <>
            <TripSummaryBar
                total={total}
                isLoading={isLoading}
                drawerIsOpen={drawerIsOpen}
                setDrawerIsOpen={setDrawerIsOpen}
                renderNavButtons={renderNavButtons}
            />

            <BottomDrawer
                isOpen={drawerIsOpen}
                onClose={handleClose}
                shouldHaveExtraBottomPadding
            >
                {children}
            </BottomDrawer>
        </>
    )
}
